"use strict";
import React from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import {
    Accordion
} from "react-bootstrap";
import {
    Button
} from "react-bootstrap";
import {
    ButtonGroup
} from "react-bootstrap";
import {
    ButtonToolbar
} from "react-bootstrap";
import {
    Card
} from "react-bootstrap";
import {
    CardGroup
} from "react-bootstrap";
import {
    Container
} from "react-bootstrap";
import {
    Col
} from "react-bootstrap";
import {
    Collapse
} from "react-bootstrap";
import {
    Row
} from "react-bootstrap";
import {
    Form
} from "react-bootstrap";
import {
    InputGroup
} from "react-bootstrap";
import {
    ListGroup
} from "react-bootstrap";
import {
    Modal
} from "react-bootstrap";
import {
    Overlay
} from "react-bootstrap";
import {
    Popover
} from "react-bootstrap";
import copyToClipboard from "copy-to-clipboard";
var use_effect = React["useEffect"],
    use_ref = React["useRef"],
    use_layout_effect = React["useLayoutEffect"];
var class_name = ((obj) => {
    return obj.constructor.name;
});
var object_p = ((v) => {
    return ((typeof(v)) === "object");
});
var string_p = ((v) => {
    return (((typeof(v)) === "string") || ((object_p(v)) && ((class_name(v)) === "String")));
});
var number_p = ((v) => {
    return ((typeof(v)) === "number");
});
var member_p = ((v, lst) => {
    return ((lst.includes)(v));
});
var ref_qfalse = ((obj, name) => {
    var val = obj[name];
    return (((val === undefined) === false) ? val : false);
});

function undefined_p(x) {
    return (x === undefined);
};
var array_append = ((a1, a2) => {
    var e = [];
    return ((e.concat)(a1, a2));
});
var string_append_m = ((a) => {
    var s = ""; {
        var a = a,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((x) => {
                (s = ((s.concat)(x)));
                return (i += 1);
            })(a[i]));
        };
        undefined;
    }
    return s;
});

function equal_string_arrays_p(a1, a2) {
    return ((a1.length === a2.length) && (((b) => {
        {
            var a = a1,
                n = a.length,
                i = 0,
                a_3 = a2,
                n_1 = a_3.length,
                i_2 = 0,
                cont = true;
            while ((true && cont && (i < n) && (i_2 < n_1))) {
                (((x, y) => {
                    skip: while (true) {
                        (b = (b && (x == y)));
                        if (!((!b) === false)) {
                            (cont = false);
                            break skip;
                        } else;;
                        (i += 1);
                        (i_2 += 1);
                        break skip;
                    };;
                    return undefined;
                })(a[i], a_3[i_2]));
            };
            undefined;
        }
        return b;
    })(true)));
};

function equal_number_arrays_p(a1, a2) {
    return ((a1.length === a2.length) && (((b) => {
        {
            var a = a1,
                n = a.length,
                i = 0,
                a_6 = a2,
                n_4 = a_6.length,
                i_5 = 0,
                cont = true;
            while ((true && cont && (i < n) && (i_5 < n_4))) {
                (((x, y) => {
                    skip: while (true) {
                        (b = (b && (x == y)));
                        if (!((!b) === false)) {
                            (cont = false);
                            break skip;
                        } else;;
                        (i += 1);
                        (i_5 += 1);
                        break skip;
                    };;
                    return undefined;
                })(a[i], a_6[i_5]));
            };
            undefined;
        }
        return b;
    })(true)));
};

function random(n) {
    return ((Math.floor)((((Math.random)()) * n)));
};

function random_from_array(a) {
    return a[(random(a.length))];
};

function AwesomeIcon(props) {
    var kind = (((t) => {
        return (((false || (t === "regular")) === false) ? (((false || (t === "solid")) === false) ? ((() => {
            return "fas";
        })()) : ((() => {
            return "fas";
        })())) : ((() => {
            return "far";
        })()));
    })(props.kind));
    return ((React["createElement"])("i", {
        className: (kind + "  fa-" + props.name + " " + props.style)
    }));
};

function BootstrapIcon(props) {
    var style = (((t) => {
        return (((false || (t === undefined)) === false) ? ((() => {
            return props.style;
        })()) : ((() => {
            return "";
        })()));
    })(props.style));
    return ((React["createElement"])("i", {
        className: ("bi " + "bi-" + props.name + " " + style)
    }));
};

function typeset_entire_page() {
    return (((!((MathJax["typesetClear"] === undefined) || (MathJax.typeset === undefined))) === false) ? undefined : ((() => {
        ((MathJax["typesetClear"])());
        return (((() => {
            var try_result = false;
            try {
                (try_result = ((MathJax.typeset)()));
            } catch (exn) {
                (try_result = ((((exn_7) => {
                    return (setTimeout(typeset_entire_page, 1000));
                }))(exn)));
            };
            return try_result;
        }))());
    })()));
};

function typeset_elements(elms) {
    return (((!((MathJax["typesetClear"] === undefined) || (MathJax.typeset === undefined))) === false) ? undefined : ((() => {
        ((MathJax["typesetClear"])());
        return ((MathJax.typeset)(elms));
    })()));
};
async function fetch_item(exercise_id, variant_id) {
    var url = ("/static/json/exercises/" + exercise_id + "/" + variant_id + ".json"),
        response = await (fetch(url)),
        data = await ((response.json)());
    return data;
};
async function register_attempt(exercise_id, variant_id, answer, is_correct) {
    var url = ("/attempt/" + exercise_id + "/" + variant_id),
        response = await (fetch(url, {
            method: "POST",
            headers: {
                Content_Type: "application/json"
            },
            body: ((JSON.stringify)({
                answer: answer,
                iscorrect: is_correct
            }))
        }));
    return "ok";
};

function ExerciseBody(props) {
    return ((React["createElement"])("div", {
        className: "exercise-body"
    }, ((React["createElement"])("div", {
        dangerouslySetInnerHTML: {
            __html: props.body
        }
    }))));
};

function result_type__gtext(rt) {
    return (((t) => {
        return (((false || (t === "integer")) === false) ? (((false || (t === "number")) === false) ? (((false || (t === "float2")) === false) ? (((false || (t === "float4")) === false) ? (((false || (t === "float8")) === false) ? (((false || (t === "text")) === false) ? (((false || (t === "letter")) === false) ? (((false || (t === "expression")) === false) ? (((false || (t === "yesno")) === false) ? (((false || (t === "point")) === false) ? (((false || (t === "interval")) === false) ? (((false || (t === "vector")) === false) ? (((false || (t === "equation")) === false) ? (((false || (t === "antiderivative")) === false) ? (((false || (t === "integerset")) === false) ? ((() => {
            return "Tekst";
        })()) : ((() => {
            return "Mængde";
        })())) : ((() => {
            return "Udtryk (en stamfunktion)";
        })())) : ((() => {
            return "Ligning";
        })())) : ((() => {
            return "Vektor";
        })())) : ((() => {
            return "Interval";
        })())) : ((() => {
            return "Punkt";
        })())) : ((() => {
            return "Ja eller nej";
        })())) : ((() => {
            return "Udtryk";
        })())) : ((() => {
            return "Bogstav";
        })())) : ((() => {
            return "Tekst";
        })())) : ((() => {
            return "Kommatal (8 cifre efter decimalpunktummet)";
        })())) : ((() => {
            return "Kommatal (4 cifre efter decimalpunktummet)";
        })())) : ((() => {
            return "Kommatal (2 cifre efter decimalpunktummet)";
        })())) : ((() => {
            return "Tal";
        })())) : ((() => {
            return "Heltal";
        })()));
    })(rt));
};
var next_unique_id = 0;

function unique_id() {
    var id = next_unique_id;
    (next_unique_id = (next_unique_id + 1));
    return ("exerciseanswerinput" + id);
};

function last_unique_id() {
    var id = next_unique_id;
    return ("exerciseanswerinput" + id);
};

function ExerciseAnswerInput(props) {
    var on_change = ((e) => {
        return ((props["set_user_answer"])(e.target.value));
    });
    return ((React["createElement"])(Form, null, ((React["createElement"])(InputGroup, null, ((React["createElement"])(InputGroup["Prepend"], null, ((React["createElement"])(InputGroup["Text"], null, (result_type__gtext(props["result_type"])))))), ((React["createElement"])(Form["Control"], {
        placeholder: "Svar",
        id: (unique_id()),
        className: "mathquill-math-field",
        onChange: on_change,
        onKeyUp: props["onKeyUp"],
        onKeyDown: props["onKeyDown"],
        type: "text",
        ref: props["input_ref"],
        disabled: props.disabled,
        tabIndex: 0
    })))), ((React["createElement"])(Form["Text"], {
        className: "text-muted"
    }, props["error_message"]))));
};

function ExerciseModal(props) {
    (use_effect(typeset_entire_page));
    var state_temp = ((React["useState"])("check")),
        button_state = state_temp[0],
        set_button_state = state_temp[1];
    var state_temp_8 = ((React["useState"])("")),
        user_answer = state_temp_8[0],
        set_user_answer = state_temp_8[1];
    var state_temp_9 = ((React["useState"])("")),
        error_message = state_temp_9[0],
        set_error_message = state_temp_9[1];
    var state_temp_10 = ((React["useState"])(false)),
        solution_seen = state_temp_10[0],
        set_solution_seen = state_temp_10[1];
    var state_temp_11 = ((React["useState"])(false)),
        show_check_overlay = state_temp_11[0],
        set_show_check_overlay = state_temp_11[1];
    var state_temp_12 = ((React["useState"])(false)),
        show_next_button = state_temp_12[0],
        set_show_next_button = state_temp_12[1];
    var state_temp_13 = ((React["useState"])(false)),
        show_solution = state_temp_13[0],
        set_show_solution = state_temp_13[1];
    var state_temp_14 = ((React["useState"])((props.mode || "single"))),
        mode = state_temp_14[0],
        set_mode = state_temp_14[1];
    var state_temp_15 = ((React["useState"])((props["exercise_ids"] || [props["exercise_id"]]))),
        exercise_ids = state_temp_15[0],
        set_exercise_ids = state_temp_15[1];
    var state_temp_16 = ((React["useState"])(props["exercise_id"])),
        exercise_id = state_temp_16[0],
        set_exercise_id = state_temp_16[1];
    var state_temp_17 = ((React["useState"])(props["variant_id"])),
        variant_id = state_temp_17[0],
        set_variant_id = state_temp_17[1];
    var state_temp_18 = ((React["useState"])(false)),
        data = state_temp_18[0],
        set_data = state_temp_18[1];
    var state_temp_19 = ((React["useState"])((((t) => {
            return (((false || (t === "single") || (t === "serial") || (t === "adaptive")) === false) ? (((false || (t === "shuffle")) === false) ? undefined : ((() => {
                return (random(exercise_ids.length));
            })())) : ((() => {
                return 1;
            })()));
        })(props.mode)))),
        exercise_index = state_temp_19[0],
        set_exercise_index = state_temp_19[1];
    var state_temp_20 = ((React["useState"])(false)),
        pop_title = state_temp_20[0],
        set_pop_title = state_temp_20[1];
    var state_temp_21 = ((React["useState"])(false)),
        pop_text = state_temp_21[0],
        set_pop_text = state_temp_21[1];
    var state_temp_22 = ((React["useState"])([false, false, false, false, false])),
        history = state_temp_22[0],
        set_history = state_temp_22[1];
    var state_temp_23 = ((React["useState"])(false)),
        focus_answer_input = state_temp_23[0],
        set_focus_answer_input = state_temp_23[1];
    var answer_input_element_ref = (use_ref(false));
    var check_button_ref = (use_ref(false));
    (use_effect((() => {
        return ((focus_answer_input === false) ? undefined : ((() => {
            var current_answer_element = answer_input_element_ref.current;
            ((current_answer_element.focus)());
            return (set_focus_answer_input(false));
        })()));
    })));
    var toggle_check_overlay = (() => {
        return (set_show_check_overlay((!show_check_overlay)));
    });
    (((!data) === false) ? undefined : ((() => {
        return (((t) => {
            return (((false || (t === "single") || (t === false)) === false) ? (((false || (t === "serial")) === false) ? (((false || (t === "shuffle") || (t === "adaptive")) === false) ? undefined : ((() => {
                var eid = (random_from_array(props["exercise_ids"]));
                return (((fetch_item(eid, (random(100)))).then)(((d) => {
                    return ((d === false) ? (((fetch_item(eid, 0)).then)(set_data)) : (set_data(d)));
                })));
            })())) : ((() => {
                var eid = (exercise_id || props["exercise_ids"][0]),
                    vid = (variant_id || 0);
                return (((fetch_item(eid, vid)).then)(((d) => {
                    return ((d === false) ? (((fetch_item(eid, 0)).then)(set_data)) : (set_data(d)));
                })));
            })())) : ((() => {
                return (((fetch_item((exercise_id || props["exercise_id"]), (variant_id || props["variant_id"]))).then)(set_data));
            })()));
        })(props.mode));
    })()));
    var parse = ((x) => {
        return (((string_p(x)) === false) ? (((number_p(x)) === false) ? ((() => {
            return false;
        })()) : ((() => {
            return ((KAS.parse)(((x["toString"])())));
        })())) : ((() => {
            return ((KAS.parse)(x));
        })()));
    });
    var compare_float2 = ((x, y) => {
        return (((Math.abs)((x - y))) <= 0.01);
    });
    var compare_float4 = ((x, y) => {
        return (((Math.abs)((x - y))) <= 0.0001);
    });
    var compare_float8 = ((x, y) => {
        return (((Math.abs)((x - y))) <= 1e-8);
    });
    var compare_float = ((x, y) => {
        return (((t) => {
            return (((false || (t === "float2")) === false) ? (((false || (t === "float4")) === false) ? (((false || (t === "float8")) === false) ? ((() => {
                return (compare_float4(x, y));
            })()) : ((() => {
                return (compare_float8(x, y));
            })())) : ((() => {
                return (compare_float4(x, y));
            })())) : ((() => {
                return (compare_float2(x, y));
            })()));
        })(data["result_type"]));
    });
    var compare = ((x, y) => {
        return ((((number_p(x)) && (number_p(y))) === false) ? (((number_p(x)) === false) ? (((number_p(y)) === false) ? ((() => {
            var px = (parse(x));
            var py = (parse(y));
            var ex = px.expr;
            var ey = py.expr;
            return ((ex === false) ? ((() => {
                (set_pop_title("Desværre"));
                return (set_pop_text("Indtastning ikke genkendt."));
            })()) : ((() => {
                return ((ex.equals)(ey));
            })()));
        })()) : ((() => {
            var e = (parse(x));
            (((!e) === false) ? undefined : ((() => {
                (set_pop_title("Desværre"));
                return (set_pop_text("Indtastning ikke genkendt."));
            })()));
            return (e && (compare_float(y, ((e.expr.eval)()))));
        })())) : ((() => {
            var e = (parse(y));
            (((!e) === false) ? undefined : ((() => {
                (set_pop_title("Desværre"));
                return (set_pop_text("Indtastning ikke genkendt."));
            })()));
            return (e && (compare_float(x, ((e.expr.eval)()))));
        })())) : ((() => {
            return (compare_float(x, y));
        })()));
    });
    var check_answer = ((ans) => {
        (ans = ((ans.replace)("−", "-")));
        return (((() => {
            var try_result = false;
            try {
                (try_result = ((((data["result_type"] === "point") || (data["result_type"] === "vector") || (data["result_type"] === "interval")) === false) ? (((data["result_type"] === "integerset") === false) ? ((((data["result_type"] === "float2") || (data["result_type"] === "float4")) === false) ? (((data["result_type"] === "number") === false) ? (((data["result_type"] === "equation") === false) ? (((data["result_type"] === "antiderivative") === false) ? ((data.result === false) ? ((() => {
                    return false;
                })()) : ((() => {
                    ((((data["result_type"] === "letter") || (data["result_type"] === "yesno")) === false) ? undefined : ((() => {
                        return (ans = ((ans["toLowerCase"])()));
                    })()));
                    ((console.log)(((KAS.parse)(ans))));
                    ((console.log)("single value parse ans with parse-comma"));
                    ((console.log)((parse_comma_number(ans))));
                    (ans = ((ans.replace)("≤", "<=")));
                    (ans = ((ans.replace)("≥", ">=")));
                    var e1 = ((KAS.parse)(ans)).expr;
                    (((e1 === undefined) === false) ? undefined : ((() => {
                        return (e1 = ((KAS.parse)((replace_comma_with_period(ans)))).expr);
                    })()));
                    ((console.log)(e1));
                    ((console.log)("data.result"));
                    ((console.log)(data.result));
                    ((console.log)(((KAS.parse)(data.result))));
                    var e2 = ((KAS.parse)(data.result)).expr;
                    ((console.log)("res:"));
                    ((console.log)(e2));
                    return ((e2.equals)(e1));
                })())) : ((() => {
                    var ans1 = (((((KAS.parse)(ans)).expr === undefined) === false) ? (replace_comma_with_period(ans)) : ans);
                    var f = ((KAS.parse)((ans1 + "-(" + data.result + ")")));
                    var f1 = ((f.expr.simplify)());
                    return ((((f1.name)()) === "Int") || (((f1.name)()) === "Float") || (((f1.name)()) === "Rational") || ((f1.equals)(((KAS.parse)("c")).expr)) || ((f1.equals)(((KAS.parse)("k")).expr)));
                })())) : ((() => {
                    (ans = ((ans.replace)("≤", "<=")));
                    (ans = ((ans.replace)("≥", ">=")));
                    var a = ((KAS.parse)(ans));
                    var r = ((KAS.parse)(data.result));
                    return (((!a.parsed) === false) ? (((!r.parsed) === false) ? ((() => {
                        return ((KAS.compare)(a.expr, r.expr)).equal;
                    })()) : ((() => {
                        return ((console.log)("ligning: Result not parsed. !!!"));
                    })())) : ((() => {
                        return ((console.log)("ligning: Answer not parsed. "));
                    })()));
                })())) : ((() => {
                    var e1 = ((KAS.parse)(ans)).expr;
                    (((e1 === undefined) === false) ? undefined : ((() => {
                        return (e1 = ((KAS.parse)((replace_comma_with_period(ans)))).expr);
                    })()));
                    var e2 = ((KAS.parse)(data.result)).expr;
                    return ((KAS.compare)(e1, e2)).equal;
                })())) : ((() => {
                    var a = (parse_comma_number(ans));
                    var r = (parse_comma_number(data.result));
                    return (((a === undefined) === false) ? (((r === undefined) === false) ? ((() => {
                        return (compare(a, r));
                    })()) : ((() => {
                        return ((console.log)("Result not parsed. !!!"));
                    })())) : ((() => {
                        return ((console.log)("Answer not parsed."));
                    })()));
                })())) : ((() => {
                    var r = (parse_integer_set(data.result));
                    var a = (parse_integer_set(ans));
                    return (((string_p(a)) === false) ? ((() => {
                        return (equal_number_arrays_p(a, r));
                    })()) : ((() => {
                        (set_pop_title("Indtastning ikke genkendt"));
                        return (set_pop_text(a));
                    })()));
                })())) : ((() => {
                    var r = (parse_point(data.result));
                    var a = (parse_point(ans));
                    return (((string_p(a)) === false) ? ((() => {
                        return ((compare(a[0], r[0])) && (compare(a[1], r[1])));
                    })()) : ((() => {
                        return false;
                    })()));
                })())));
            } catch (exn) {
                (try_result = ((((exn_24) => {
                    ((console.log)(("Exception: " + exn_24)));
                    (set_error_message("Indtastning ikke genkendt."));
                    return false;
                }))(exn)));
            };
            return try_result;
        }))());
    });
    var initial_history = (() => {
        return ["none", "none", "correct", "wrong", "correct"];
    });
    var add_attempt_to_history = ((result) => {
        var r = ((n) => {
            return history[n];
        });
        return (set_history([(r(1)), (r(2)), (r(3)), (r(4)), result]));
    });
    var color__glight = ((col, sym) => {
        return ((React["createElement"])("div", {
            style: {
                color: col,
                display: "inline"
            }
        }, sym));
    });
    var result__glight = ((result) => {
        return (((t) => {
            return (((false || (t === "wrong")) === false) ? (((false || (t === "correct")) === false) ? (((false || (t === "skipped")) === false) ? (((false || (t === false)) === false) ? ((() => {
                return (color__glight("purple", "?"));
            })()) : ((() => {
                return (color__glight("lightgray", "⬤"));
            })())) : ((() => {
                return (color__glight("orange", "⬤"));
            })())) : ((() => {
                return (color__glight("green", "⬤"));
            })())) : ((() => {
                return (color__glight("red", "⬤"));
            })()));
        })(result));
    });
    var history_advice = (() => {
        var n = (((s) => {
            {
                var a = history,
                    n = a.length,
                    i = 0;
                while ((true && true && (i < n))) {
                    (((x) => {
                        (s += (((x === "correct") === false) ? 0 : 1));
                        return (i += 1);
                    })(a[i]));
                };
                undefined;
            }
            return s;
        })(0));
        return (((n >= 4) === false) ? "" : "Næste opgavetype");
    });
    var history__glights = (() => {
        var h = ((n) => {
            return (result__glight(history[n]));
        });
        return ((React["createElement"])("div", {
            className: "mr-auto"
        }, (h(0)), (h(1)), (h(2)), (h(3)), (h(4))));
    });
    var check_button_text = (() => {
        return (((t) => {
            return (((false || (t === "check")) === false) ? (((false || (t === "try-again")) === false) ? (((false || (t === "check-again")) === false) ? (((false || (t === "next-question")) === false) ? ((() => {
                ((console.log)(("buttons-text: " + "unexpected button state")));
                return "Sigh";
            })()) : ((() => {
                return "Næste spørgsmål";
            })())) : ((() => {
                return "Tjek igen";
            })())) : ((() => {
                return "Prøv igen";
            })())) : ((() => {
                return "Tjek";
            })()));
        })(button_state));
    });
    var next_button_text = (() => {
        return ((solution_seen === false) ? "Hop over" : "Næste");
    });
    var reset_answer_input_state = ((who) => {
        var current_answer_element = answer_input_element_ref.current;
        (set_button_state("check"));
        (set_user_answer(""));
        (current_answer_element["value"] = "");
        ((current_answer_element.focus)());
        (set_focus_answer_input(true));
        (set_error_message(""));
        (set_solution_seen(false));
        (set_show_solution(false));
        (set_pop_title(false));
        (set_pop_text(false));
        (set_show_check_overlay(false));
        (set_show_next_button(false));
        (((t) => {
            return (((false || (t === "single") || (t === false)) === false) ? (((false || (t === "serial")) === false) ? (((false || (t === "shuffle") || (t === "adaptive")) === false) ? undefined : ((() => {
                (set_exercise_id((random_from_array(exercise_ids))));
                return (set_variant_id((random((data.variants || 1)))));
            })())) : ((() => {
                (set_variant_id((random((data.variants || 1)))));
                return (((t_25) => {
                    return (((false || (t_25 === "next-type")) === false) ? undefined : ((() => {
                        (set_exercise_index(((((exercise_index + 1) === exercise_ids.length) === false) ? (exercise_index + 1) : 0)));
                        return (set_exercise_id(exercise_ids[exercise_index]));
                    })()));
                })(who));
            })())) : ((() => {
                return (set_variant_id((random((data.variants || 1)))));
            })()));
        })(mode));
        return (set_data(false));
    });
    var on_check_button_click = (() => {
        var current_answer_element = answer_input_element_ref.current;
        return (((t) => {
            return (((false || (t === "check") || (t === "check-again")) === false) ? (((false || (t === "try-again")) === false) ? (((false || (t === "next-question")) === false) ? undefined : ((() => {
                (set_button_state("check"));
                return (reset_answer_input_state());
            })())) : ((() => {
                (set_button_state("check-again"));
                ((current_answer_element.focus)());
                (set_show_check_overlay(false));
                return (set_show_next_button(false));
            })())) : ((() => {
                (((check_answer(user_answer)) === false) ? ((() => {
                    (register_attempt(props["exercise_id"], (variant_id || props["variant_id"]), user_answer, false));
                    (add_attempt_to_history("wrong"));
                    (set_button_state("try-again"));
                    return (set_show_next_button(true));
                })()) : ((() => {
                    (register_attempt(props["exercise_id"], (variant_id || props["variant_id"]), user_answer, true));
                    (add_attempt_to_history("correct"));
                    (set_button_state("next-question"));
                    return (set_show_next_button(false));
                })()));
                return (set_show_check_overlay(true));
            })()));
        })(button_state));
    });
    var on_next_button_click = (() => {
        return (reset_answer_input_state());
    });
    var on_next_type_click = (() => {
        return (reset_answer_input_state("next-type"));
    });
    var popover_title = (() => {
        return (((t) => {
            return (((false || (t === "try-again")) === false) ? (((false || (t === "next-question")) === false) ? undefined : ((() => {
                return (pop_title || "Fint");
            })())) : ((() => {
                return (pop_title || "Ikke helt...");
            })()));
        })(button_state));
    });
    var popover_text = (() => {
        return (((t) => {
            return (((false || (t === "try-again")) === false) ? (((false || (t === "next-question")) === false) ? undefined : ((() => {
                return (pop_text || "Fint.");
            })())) : ((() => {
                return (pop_text || "Prøv igen eller hop opgaven over.");
            })()));
        })(button_state));
    });
    var on_close_click = (() => {
        return ((props["onHide"])());
    });
    var previous_answer_key_down = false;
    var on_answer_key_down = ((e) => {
        ((console.log)(e));
        ((console.log)(e["nativeEvent"]));
        (((e.key === "Enter") === false) ? undefined : ((() => {
            return ((e["preventDefault"])());
        })()));
        return (previous_answer_key_down = e.key);
    });
    var on_answer_key_up = ((e) => {
        ((e["preventDefault"])());
        return ((((e.key === "Enter") && (previous_answer_key_down === "Enter")) === false) ? undefined : ((() => {
            return ((check_button_ref.current.focus)());
        })()));
    });
    var on_show_solution_click = ((e) => {
        (set_show_check_overlay(false));
        (set_show_solution((!show_solution)));
        return ((((button_state === "check") || (button_state === "check-again") || (button_state === "try-again")) === false) ? undefined : ((() => {
            (set_solution_seen(true));
            return (set_button_state("next-question"));
        })()));
    });
    return ((React["createElement"])(Modal, ((Object.assign)({}, {
        centered: true,
        size: "lg",
        onShow: (function() {
            return ((answer_input_element_ref.current.focus)());
        }),
        aria_labelledby: "exercise-modal"
    }, props)), ((React["createElement"])(Modal["Header"], {
        closeButton: ""
    }, ((React["createElement"])(Modal["Title"], {
        id: "exercise-modal"
    }, data.title)), "\n", ((React["createElement"])("a", {
        href: "#",
        onClick: on_close_click
    }, ((React["createElement"])(BootstrapIcon, {
        name: "x-square-fill",
        style: "close-icon"
    })))))), "\n", ((React["createElement"])(Modal["Body"], null, ((React["createElement"])(ExerciseBody, {
        body: data.body
    })), ((React["createElement"])(ExerciseAnswerInput, {
        result_type: data["result_type"],
        error_message: error_message,
        disabled: solution_seen,
        set_user_answer: set_user_answer,
        input_ref: answer_input_element_ref,
        onKeyUp: on_answer_key_up,
        onKeyDown: on_answer_key_down
    })), ((React["createElement"])("br", null)), ((show_solution === false) ? undefined : ((() => {
        return ((React["createElement"])(ExerciseBody, {
            body: (data.solution || ("<div>\\[" + data.result + "\\]</div>") || "Mangler")
        }));
    })())))), "\n", ((React["createElement"])(Modal["Footer"], null, (history__glights()), (((t) => {
        return (((false || (t === "try-again") || (t === "check-again") || (t === "next-question")) === false) ? ((() => {
            return null;
        })()) : ((() => {
            return ((React["createElement"])(Button, {
                onClick: on_show_solution_click
            }, ((show_solution === false) ? ((data.solution === false) ? "Vis Facit" : "Vis Løsning") : ((data.solution === false) ? "Skjul Facit" : "Skjul Løsning"))));
        })()));
    })(button_state)), (((!(solution_seen && (button_state === "check"))) === false) ? undefined : ((() => {
        return ((React["createElement"])(Button, {
            ref: check_button_ref,
            tabIndex: 0,
            variant: (((user_answer === "") === false) ? "primary" : "secondary"),
            disabled: (user_answer === ""),
            onClick: on_check_button_click
        }, (check_button_text())));
    })())), ((React["createElement"])(Overlay, {
        key: "2",
        target: (function() {
            return check_button_ref.current;
        }),
        placement: "top",
        show: show_check_overlay
    }, ((args) => {
        {
            var val = args,
                placement = val.placement,
                scheduleUpdate = val["scheduleUpdate"],
                arrowProps = val["arrowProps"],
                outOfBoundaries = val["outOfBoundaries"],
                _show = val.show,
                props_26 = val;
            (delete props_26.placement);
            (delete props_26["scheduleUpdate"]);
            (delete props_26["arrowProps"]);
            (delete props_26["outOfBoundaries"]);
            (delete props_26.show);
        }
        var ps = props_26.style;
        return ((React["createElement"])(Popover, ((Object.assign)({}, {
            style: props_26.style,
            id: "a-popover",
            placement: "top"
        }, props_26)), ((React["createElement"])(Popover["Title"], {
            as: "h3"
        }, (popover_title()))), ((React["createElement"])(Popover["Content"], null, (popover_text())))));
    }))), (((show_next_button && (!(button_state === "next-question"))) === false) ? undefined : ((() => {
        return ((React["createElement"])(Button, {
            tabIndex: 0,
            variant: "primary",
            onClick: on_next_button_click
        }, (next_button_text())));
    })())), ((((mode === "serial") && show_next_button) === false) ? undefined : ((() => {
        return ((React["createElement"])(ButtonGroup, null, ((React["createElement"])(Button, {
            tabIndex: 10,
            variant: "primary",
            onClick: on_next_type_click
        }, "Næste opgavetype"))));
    })()))))));
};

function App(props) {
    var state_temp = ((React["useState"])(false)),
        modal_show = state_temp[0],
        set_modal_show = state_temp[1];
    var state_temp_27 = ((React["useState"])((props.mode || "single"))),
        mode = state_temp_27[0],
        set_mode = state_temp_27[1];
    var state_temp_28 = ((React["useState"])(props["exercise_ids"])),
        exercise_ids = state_temp_28[0],
        set_exercise_ids = state_temp_28[1];
    var state_temp_29 = ((React["useState"])(props["exercise_id"])),
        exercise_id = state_temp_29[0],
        set_exercise_id = state_temp_29[1];
    var state_temp_30 = ((React["useState"])("0")),
        variant_id = state_temp_30[0],
        set_variant_id = state_temp_30[1];
    var handle_start_on_click = (() => {
        return (set_modal_show(true));
    });
    return ((React["createElement"])(ButtonToolbar, null, ((React["createElement"])(Button, {
        variant: "primary",
        onClick: handle_start_on_click,
        focus: "true"
    }, "Begynd")), ((React["createElement"])(ExerciseModal, {
        show: modal_show,
        onHide: (function() {
            return (set_modal_show(false));
        }),
        mode: mode,
        exercise_ids: exercise_ids,
        exercise_id: exercise_id,
        variant_id: variant_id
    }))));
};

function Subject(props) {
    var name = "Algebra";
    return ((React["createElement"])(Card, {
        bg: "primary",
        text: "white"
    }, ((React["createElement"])(Card["Header"], null, name)), "\n", ((React["createElement"])(Card["Body"], null, ((React["createElement"])(Card["Title"], null, "Titlen")), ((React["createElement"])(Card["Text"], null, "Noget Tekst"))))));
};
async function fetch_teasers(tag) {
    var url = ("/static/json/teasers/" + tag + ".json"),
        response = await (fetch(url)),
        data = await ((response.json)());
    return data;
};
async function fetch_id_to_group() {
    var url = ("/static/json/id-to-group.json"),
        response = await (fetch(url)),
        data = await ((response.json)());
    return data;
};

function Teaser(props) {
    var state_temp = ((React["useState"])(props.mode)),
        mode = state_temp[0],
        set_mode = state_temp[1];
    var state_temp_31 = ((React["useState"])(false)),
        modal_show = state_temp_31[0],
        set_modal_show = state_temp_31[1];
    var state_temp_32 = ((React["useState"])(props.id)),
        exercise_id = state_temp_32[0],
        set_exercise_id = state_temp_32[1];
    var state_temp_33 = ((React["useState"])(props.variant)),
        variant_id = state_temp_33[0],
        set_variant_id = state_temp_33[1];
    var state_temp_34 = ((React["useState"])(true)),
        body_collapsed_p = state_temp_34[0],
        set_body_collapsed_p = state_temp_34[1];
    var state_temp_35 = ((React["useState"])(true)),
        selected_p = state_temp_35[0],
        set_selected_p = state_temp_35[1];
    var handle_start_on_click = (() => {
        return (set_modal_show(true));
    });
    var tag = props.tag;
    var t = props.title;
    var s = props.summary;
    var i = props.id;
    var url = ("/opgave/" + i);
    (use_effect((() => {
        return (set_mode(props.mode));
    }), [props]));
    var caret_right = ((React["createElement"])("div", {
        key: "collapsed"
    }, ((React["createElement"])(BootstrapIcon, {
        name: "caret-right-fill"
    }))));
    var caret_down = ((React["createElement"])("div", {
        key: "not-collapsed"
    }, ((React["createElement"])(BootstrapIcon, {
        name: "caret-down-fill"
    }))));
    var on_toggle = (() => {
        return (set_body_collapsed_p((!body_collapsed_p)));
    });
    var circle = ((React["createElement"])("div", {
        key: "not-checked"
    }, ((React["createElement"])(BootstrapIcon, {
        name: "circle"
    }))));
    var circle_check = ((React["createElement"])("div", {
        key: "checked"
    }, ((React["createElement"])(BootstrapIcon, {
        name: "check-circle-fill"
    }))));
    var check_on_toggle = (() => {
        ((console.log)("before: ", (get_deselected_ids())));
        ((selected_p === false) ? (delete_deselected_id(i)) : (add_deselected_id(i)));
        (set_selected_p((!selected_p)));
        return ((console.log)("after: ", (get_deselected_ids())));
    });
    var card_color_style = ((selected_p === false) ? {
        "background-color": "#00000008"
    } : {});
    return (((t_36) => {
        return (((false || (t_36 === "search-result")) === false) ? ((() => {
            return ((React["createElement"])(Card, {
                bg: "primary",
                text: "white",
                style: {
                    marginBottom: "1rem"
                }
            }, ((React["createElement"])(Card["Header"], null, t)), ((React["createElement"])(Card["Body"], {
                style: {
                    color: "black",
                    backgroundColor: "white"
                }
            }, ((React["createElement"])(Card["Text"], {
                dangerouslySetInnerHTML: {
                    __html: s
                }
            })), ((React["createElement"])("div", null, ((React["createElement"])("a", {
                href: "#",
                onClick: handle_start_on_click
            }, "Regn")), ((React["createElement"])("span", {
                className: "exercise-id"
            }, ("opgave-id: " + exercise_id))))), ((React["createElement"])(ExerciseModal, {
                show: modal_show,
                onHide: (function() {
                    return (set_modal_show(false));
                }),
                mode: "single",
                exercise_id: exercise_id,
                variant_id: variant_id
            }))))));
        })()) : ((() => {
            return ((React["createElement"])("div", null, ((React["createElement"])(Card, {
                style: card_color_style
            }, ((React["createElement"])(Card["Body"], null, ((React["createElement"])(Card["Text"], null, ((React["createElement"])("span", null, ((React["createElement"])(Button, {
                style: {
                    "vertical-align": "text-top"
                },
                variant: "link",
                onClick: check_on_toggle
            }, ((selected_p === false) ? circle : circle_check))), ((React["createElement"])("div", {
                style: {
                    display: "inline-block",
                    "vertical-align": "text-top"
                }
            }, ((React["createElement"])("div", {
                dangerouslySetInnerHTML: {
                    __html: ("<b>" + t + "</b> </br>" + s)
                }
            })))), ((React["createElement"])("div", {
                style: {
                    float: "right"
                }
            }, ((React["createElement"])("a", {
                href: "#",
                onClick: handle_start_on_click,
                style: {
                    display: "inline-block",
                    text_align: "right"
                }
            }, "Eksempel")), ((React["createElement"])("div", {
                className: "exercise-id-search"
            }, ("opgave-id: " + i))), ((React["createElement"])(ExerciseModal, {
                show: modal_show,
                onHide: (function() {
                    return (set_modal_show(false));
                }),
                mode: "single",
                exercise_id: exercise_id,
                variant_id: variant_id
            }))))))))))))));
        })()));
    })(mode));
};

function max(m, n) {
    return (((m < n) === false) ? m : n);
};

function first_char(s) {
    return s[0];
};

function last_char(s) {
    return s[(max(0, (s.length - 1)))];
};

function string_length(s) {
    return s.length;
};

function array__gstring(a) {
    return ((a.join)(""));
};

function string__garray(s) {
    return ((s.split)(""));
};

function filter(pred, a) {
    return ((a.filter)(pred));
};

function non_space_p(s) {
    return (!(s === " "));
};

function delete_spaces(s) {
    return (array__gstring((filter(non_space_p, (string__garray(s))))));
};

function wrapped_with_matching_parens_p(s) {
    return ((((first_char(s)) === "(") && ((last_char(s)) === ")")) || (((first_char(s)) === "[") && ((last_char(s)) === "]")) || (((first_char(s)) === "{") && ((last_char(s)) === "}")));
};

function remove_parens(s) {
    return ((s.substring)(1, ((string_length(s)) - 1)));
};

function includes_semicolon_p(s) {
    return ((s.includes)(";"));
};

function includes_comma_p(s) {
    return ((s.includes)(","));
};

function string_split(s, c) {
    return ((s.split)(c));
};

function regexp(s) {
    return (new RegExp(s));
};

function replace_char(s, from, to) {
    return ((s.replace)(from, to));
};

function replace_comma_with_period(s) {
    return (replace_char(s, ",", "."));
};

function string__gnumber(s) {
    return (parseFloat(s));
};

function compare_exercise_id(id1, id2) {
    var rx = (regexp("^([a-z]*)([0-9]*)$"));
    var m1 = ((id1.match)(rx));
    var m2 = ((id2.match)(rx));
    var tag1 = m1[1];
    var tag2 = m2[1];
    var n1 = (string__gnumber(m1[2]));
    var n2 = (string__gnumber(m2[2]));
    var res = ((((tag1 === "ks") && (tag2 === "ks")) === false) ? (((tag1 === "ks") === false) ? (((tag2 === "ks") === false) ? ((((tag1 === "san") && (tag2 === "san")) === false) ? (((tag1 === "san") === false) ? (((tag2 === "san") === false) ? ((tag1 < tag2) || ((tag1 === tag2) && (n1 < n2))) : false) : true) : (n1 < n2)) : true) : false) : (n1 < n2));
    return res;
};

function parse_comma_number(s) {
    return (((number_p(s)) === false) ? ((() => {
        var r = (regexp("^(-)?[0-9]+([,.][0-9]*)?$"));
        var m = ((s.match)(r));
        var n = (((m === null) === false) ? m[0] : false);
        return (n && (string__gnumber((replace_comma_with_period(n)))));
    })()) : ((() => {
        return s;
    })()));
};

function parse_integer(s) {
    return (((number_p(s)) === false) ? ((() => {
        var r = (regexp("^([+-])?[0-9]+$"));
        var m = ((s.match)(r));
        var n = (((m === null) === false) ? m[0] : false);
        return (n && (string__gnumber(n)));
    })()) : ((() => {
        return s;
    })()));
};

function parse_point(input_string) {
    var s = (delete_spaces(input_string));
    return (((!(wrapped_with_matching_parens_p(s))) === false) ? (((includes_semicolon_p(s)) === false) ? (((includes_comma_p(s)) === false) ? ((() => {
        return "Brug komma eller semikolon til at adskille første- og andenkoordinat. F.eks. (1.2 , 3.5)";
    })()) : ((() => {
        var a = (string_split((remove_parens(s)), ","));
        return (((!(a.length === 2)) === false) ? ((() => {
            var a0 = ((parse_comma_number(a[0])) || a[0]);
            var a1 = ((parse_comma_number(a[1])) || a[1]);
            return [a0, a1];
        })()) : ((() => {
            return "Fundet mere end et komma.";
        })()));
    })())) : ((() => {
        var a = (string_split((remove_parens(s)), ";"));
        return (((!(a.length === 2)) === false) ? ((() => {
            var a0 = ((parse_comma_number(a[0])) || a[0]);
            var a1 = ((parse_comma_number(a[1])) || a[1]);
            return [a0, a1];
        })()) : ((() => {
            return "Fundet mere end et semikolon.";
        })()));
    })())) : ((() => {
        return "Mangler parenteser om punktet.";
    })()));
};

function parse_integer_set(input_string) {
    var parse_one = ((ai) => {
        return ((parse_integer(ai)) || ai);
    });
    var remove_duplicates = ((a) => {
        return ((Array.from)((new Set(a))));
    });
    var s = (delete_spaces(input_string));
    var rx_empty = (regexp("(^[ ]*[{][ ]*[}][ ]*$)|(^[ ]*[øØ∅][ ]*$)"));
    var is_empty_set_p = ((str) => {
        return (!(((str.match)(rx_empty)) === null));
    });
    var rx_singleton = (regexp("^[ ]*[{][ ]*([+-])?([0-9]+)[ ]*[}][ ]*$"));
    var is_singleton_p = ((str) => {
        var m = ((str.match)(rx_singleton));
        return (((m === null) === false) ? m[2] : false);
    });
    return (((!(wrapped_with_matching_parens_p(s))) === false) ? (((includes_comma_p(s)) === false) ? (((is_empty_set_p(s)) === false) ? (((is_singleton_p(s)) === false) ? ((() => {
        return "Eksempler på indtastninger: {1,3,4} eller {1,2}. Den tomme mængde kan indtastes som {} eller Ø.";
    })()) : ((() => {
        return [(parseFloat((is_singleton_p(s))))];
    })())) : ((() => {
        return [];
    })())) : ((() => {
        var a = (string_split((remove_parens(s)), ","));
        var b = ((a.map)(parse_one));
        var c = (remove_duplicates(b));
        ((c.sort)());
        return c;
    })())) : ((() => {
        return (((is_empty_set_p(s)) === false) ? ("Der mangler krøllede parenteser om mængden (dvs { og } ). " + "Eksempler på indtastninger: {1,3,4} eller {1,2}. Den tomme mængde kan indtastes som {} eller Ø eller ∅.") : []);
    })()));
};

function parse_tag_query(q) {
    ((console.log)("parse-tag-query: ", q));
    var or_and_exclude = ((q.split)("-"));
    ((console.log)("  or-and-exclude: ", or_and_exclude));
    return (((t) => {
        return (((false || (t === 1)) === false) ? (((false || (t === 2)) === false) ? ((() => {
            return ((console.log)("ARGH"));
        })()) : ((() => {
            var or_query = or_and_exclude[0];
            var exclude = or_and_exclude[1];
            var res1 = (parse_tag_or(or_query));
            var res2 = (parse_exclude(exclude));
            ((console.log)("  parse-tag-query: ", res1, res2));
            return [res1, res2];
        })())) : ((() => {
            return [(parse_tag_or(q)), []];
        })()));
    })(or_and_exclude.length));
};

function parse_tag_or(q) {
    var and_queries = ((q.split)(","));
    return (((a) => {
        {
            var a_37 = and_queries,
                n = a_37.length,
                i = 0;
            while ((true && true && (i < n))) {
                (((aq) => {
                    ((a.push)((parse_tag_and(aq))));
                    return (i += 1);
                })(a_37[i]));
            };
            undefined;
        }
        return a;
    })([]));
};

function parse_tag_and(q) {
    var tags = ((q.split)("+"));
    return tags;
};

function parse_exclude(e) {
    var ids = ((e.split)(","));
    return ids;
};
async function fetch_tag_to_ids() {
    var url = ("/static/json/tag-ids/tag-to-ids.json"),
        response = await (fetch(url)),
        data = await ((response.json)());
    return data;
};

function array_intersection2(a1, a2) {
    return ((a1.filter)(((x) => {
        return ((a2.includes)(x));
    })));
};

function array_intersection(ars) {
    var result = ((ars[0].slice)()); {
        var a = ars,
            n = a.length,
            i = 0,
            i_38 = 0;
        while ((true && true && (i < n) && true)) {
            (((a, j) => {
                (((j > 0) === false) ? undefined : ((() => {
                    return (result = (array_intersection2(result, a)));
                })()));
                (i += 1);
                return (i_38 += 1);
            })(a[i], i_38));
        };
        undefined;
    }
    return result;
};

function array_union2(a1, a2) {
    var result = a1.slice; {
        var a = a2,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((x) => {
                (((!((result.includes)(x))) === false) ? undefined : ((() => {
                    return ((result.push)(x));
                })()));
                return (i += 1);
            })(a[i]));
        };
        undefined;
    }
    return result;
};

function array_union2_e(a1, a2) {
    var result = a1; {
        var a = a2,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((x) => {
                (((!((result.includes)(x))) === false) ? undefined : ((() => {
                    return ((result.push)(x));
                })()));
                return (i += 1);
            })(a[i]));
        };
        undefined;
    }
    return result;
};

function array_union(xss) {
    var result = []; {
        var a = xss,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((xs) => {
                (result = (array_union2_e(result, xs)));
                return (i += 1);
            })(a[i]));
        };
        undefined;
    }
    return result;
};

function array_substract(a1, a2) {
    var s1 = (new Set(a1)); {
        var a = a2,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((x) => {
                ((s1.delete)(x));
                return (i += 1);
            })(a[i]));
        };
        undefined;
    }
    var res = ((Array.from)(s1));
    ((console.log)("array-substract: ", a1, a2, res));
    return res;
};

function get_deselected_ids() {
    return (new Set());
};

function reset_deselected_ids() {
    return (new Set());
};

function add_deselected_id() {
    return (new Set());
};

function delete_deselected_id() {
    return (new Set());
};

function SearchField(props) {
    var state_temp = ((React["useState"])([])),
        chosen_meta = state_temp[0],
        set_chosen_meta = state_temp[1];
    var state_temp_39 = ((React["useState"])("")),
        input_value = state_temp_39[0],
        set_input_value = state_temp_39[1];
    var state_temp_40 = ((React["useState"])(false)),
        data = state_temp_40[0],
        set_data = state_temp_40[1];
    var state_temp_41 = ((React["useState"])(false)),
        tag_to_ids = state_temp_41[0],
        set_tag_to_ids = state_temp_41[1];
    var state_temp_42 = ((React["useState"])(false)),
        id_to_group = state_temp_42[0],
        set_id_to_group = state_temp_42[1];
    var state_temp_43 = ((React["useState"])(false)),
        id_to_info = state_temp_43[0],
        set_id_to_info = state_temp_43[1];
    var state_temp_44 = ((React["useState"])(false)),
        show_share_modal_p = state_temp_44[0],
        set_show_share_modal_p = state_temp_44[1];
    var state_temp_45 = ((React["useState"])((new Set()))),
        selected_ids = state_temp_45[0],
        set_selected_ids = state_temp_45[1];
    (get_deselected_ids = (() => {
        return selected_ids;
    }));
    (reset_deselected_ids = (() => {
        return (set_selected_ids((new Set())));
    }));
    (add_deselected_id = ((id) => {
        var new_ids = (new Set(selected_ids));
        ((new_ids.add)(id));
        return (set_selected_ids(new_ids));
    }));
    (delete_deselected_id = ((id) => {
        var new_ids = (new Set(selected_ids));
        ((new_ids.delete)(id));
        return (set_selected_ids(new_ids));
    }));
    var set_data_and_compute_id_to_info = ((data_46) => {
        (set_data(data_46));
        var is = {}; {
            var a = data_46.titles,
                n = a.length,
                i = 0,
                a_54 = data_46.summaries,
                n_47 = a_54.length,
                i_50 = 0,
                a_55 = data_46.ids,
                n_48 = a_55.length,
                i_51 = 0,
                a_56 = data_46.variantss,
                n_49 = a_56.length,
                i_52 = 0,
                i_53 = 0;
            while ((true && true && (i < n) && (i_50 < n_47) && (i_51 < n_48) && (i_52 < n_49) && true)) {
                (((t, s, id, vs, j) => {
                    (is[id] = {
                        title: t,
                        summary: s,
                        id: id,
                        variants: vs,
                        key: j
                    });
                    (i += 1);
                    (i_50 += 1);
                    (i_51 += 1);
                    (i_52 += 1);
                    return (i_53 += 1);
                })(a[i], a_54[i_50], a_55[i_51], a_56[i_52], i_53));
            };
            undefined;
        }
        return (set_id_to_info(is));
    });
    (((!data) === false) ? undefined : ((() => {
        return (((fetch_teasers("alle")).then)(set_data_and_compute_id_to_info));
    })()));
    (((!tag_to_ids) === false) ? undefined : ((() => {
        return (((fetch_tag_to_ids()).then)(set_tag_to_ids));
    })()));
    (((!id_to_group) === false) ? undefined : ((() => {
        return (((fetch_id_to_group()).then)(set_id_to_group));
    })()));
    var id__gtitle = ((id) => {
        var info = (id_to_info && (ref_qfalse(id_to_info, id)));
        return ((info === false) ? "<title missing>" : info.title);
    });
    var all_ids = ((Object.keys)(id_to_group));
    var id_to_options = {};
    var add_id_option = ((id, option) => {
        return (id_to_options[id] = option);
    });
    var get_id_option = ((id) => {
        return (ref_qfalse(id_to_options, id));
    });
    var all_tags = ((Object.keys)(tag_to_ids));
    var tag_to_options = {};
    var add_tag_option = ((tag, option) => {
        return (tag_to_options[tag] = option);
    });
    var get_tag_option = ((tag) => {
        return (ref_qfalse(tag_to_options, tag));
    });
    var group_names = ((id_to_group === false) ? [] : all_ids);
    var no_group_name = "andet";
    var id__ggroup = ((id) => {
        return (ref_qfalse(id_to_group, id));
    });
    var other_color = "pink";
    var group_colors = {
        "grundviden": "blue",
        "aritmetik": "blue",
        "algebra": "green",
        "funktion": "cyan",
        "differentialregning": "red",
        "geometri": "yellow",
        "plangeometri": "yellow",
        "vektor": "yellow",
        "statistik": "darkgray",
        "sandsynlighedsregning": "darkgray",
        "kombinatorik": "darkgray",
        no_group_name: "pink"
    };
    var group_color = ((group) => {
        return "black";
    });
    var id__goption = ((id) => {
        var new_option = {
            value: id,
            group: (id__ggroup(id)),
            lab: id
        };
        (add_id_option(id, new_option));
        return new_option;
    });
    var tag__goption = ((tag) => {
        var new_option = {
            value: tag,
            group: "stikord",
            lab: tag
        };
        (add_tag_option(tag, new_option));
        return new_option;
    });
    var grouped_options = ((() => {
        var all_tags_57 = ((Object.keys)((tag_to_ids || [])));
        ((all_tags_57.sort)());
        var tag_options = {
            lab: "Emner",
            options: (((a) => {
                {
                    var a_58 = all_tags_57,
                        n = a_58.length,
                        i = 0;
                    while ((true && true && (i < n))) {
                        (((tag) => {
                            ((a.push)((tag__goption(tag))));
                            return (i += 1);
                        })(a_58[i]));
                    };
                    undefined;
                }
                return a;
            })([]))
        };
        var grouped_id_options = (((a) => {
            {
                var a_59 = all_tags_57,
                    n = a_59.length,
                    i = 0;
                while ((true && true && (i < n))) {
                    (((tag) => {
                        var ids = tag_to_ids[tag];
                        ((a.push)({
                            lab: tag,
                            options: (((a_60) => {
                                {
                                    var a_63 = ids,
                                        n_61 = a_63.length,
                                        i_62 = 0;
                                    while ((true && true && (i_62 < n_61))) {
                                        (((id) => {
                                            ((a_60.push)((id__goption(id))));
                                            return (i_62 += 1);
                                        })(a_63[i_62]));
                                    };
                                    undefined;
                                }
                                return a_60;
                            })([]))
                        }));
                        return (i += 1);
                    })(a_59[i]));
                };
                undefined;
            }
            return a;
        })([]));
        return (array_append(tag_options, grouped_id_options));
    })());
    var on_change_select = ((item) => {
        return (set_chosen_meta(item));
    });
    var store_input_change_p = true;
    var on_input_change = ((v) => {
        ((console.log)(("input change: '" + v + "'")));
        ((console.log)(("input change: " + store_input_change_p)));
        return ((store_input_change_p === false) ? ((() => {
            return (store_input_change_p = true);
        })()) : ((() => {
            return (set_input_value(v));
        })()));
    });
    var on_key_down = ((e) => {
        return (((t) => {
            return (((false || (t === " ")) === false) ? ((() => {
                return false;
            })()) : ((() => {
                ((console.log)("space "));
                ((console.log)(("'" + input_value + "'")));
                ((console.log)("all-ids"));
                ((console.log)(all_ids));
                return ((((member_p(input_value, all_ids)) || (member_p(input_value, all_tags))) === false) ? undefined : ((() => {
                    ((console.log)("an exercise-id or a tag!"));
                    ((console.log)(("tag? " + (member_p(input_value, all_tags)))));
                    var new_chosen_option = (((member_p(input_value, all_ids)) === false) ? (get_tag_option(input_value)) : (get_id_option(input_value)));
                    (set_chosen_meta([...chosen_meta, new_chosen_option]));
                    ((e["preventDefault"])());
                    (store_input_change_p = false);
                    return (set_input_value(""));
                })()));
            })()));
        })(e.key));
    });
    var format_option_label = ((option, context) => {
        return (((t) => {
            return (((false || (t === "menu")) === false) ? (((false || (t === "value")) === false) ? undefined : ((() => {
                return ((React["createElement"])("div", {
                    style: {
                        color: (group_color(option.group)),
                        display: "inline"
                    }
                }, option.lab));
            })())) : ((() => {
                return (((t_64) => {
                    return (((false || (t_64 === "stikord")) === false) ? ((() => {
                        return ((React["createElement"])("div", {
                            style: {
                                color: (group_color(option.group)),
                                display: "inline"
                            }
                        }, (option.lab + " - " + (id__gtitle(option.value)))));
                    })()) : ((() => {
                        var ids = (ref_qfalse(tag_to_ids, option.value));
                        var cnt = (ids && ids.length);
                        return ((React["createElement"])("div", {
                            style: {
                                color: (group_color(option.group)),
                                display: "inline"
                            }
                        }, (option.lab + " (" + cnt + " opgaver)")));
                    })()));
                })(option.group));
            })()));
        })(context.context));
    });
    var group_styles = {
        display: "flex",
        alignItems: "center",
        justifyContents: "space-between"
    };
    var format_group_label = ((option_group) => {
        return ((React["createElement"])("div", {
            style: {
                style: group_styles,
                display: "inline"
            }
        }, option_group.lab));
    });
    var metas__gstring = (() => {
        return (((t) => {
            return (((false || (t === false) || (t === undefined)) === false) ? ((() => {
                var result = "";
                (((t_65) => {
                    return (((false || (t_65 === 0)) === false) ? (((false || (t_65 === 1)) === false) ? ((() => {
                        (result = "");
                        return ((() => {
                            var a = chosen_meta,
                                n = a.length,
                                i = 0,
                                i_ = 0,
                                t_ = chosen_meta.length;
                            while ((true && true && (i < n) && (i_ < t_))) {
                                (((meta, i) => {
                                    (result = ((result.concat)((((i === 0) === false) ? ("," + chosen_meta[i]["value"]) : chosen_meta[0]["value"]))));
                                    (i += 1);
                                    return (i_ += 1);
                                })(a[i], i_));
                            };
                            undefined;
                            return undefined;
                        })());
                    })()) : ((() => {
                        return (result = chosen_meta[0]["value"]);
                    })())) : ((() => {
                        return (result = "");
                    })()));
                })(chosen_meta.length));
                return result;
            })()) : ((() => {
                return "";
            })()));
        })(chosen_meta));
    });
    var add_deselected_to_metas_string = ((ms, ds) => {
        var deselected = ((Array.from)(ds));
        return (((t) => {
            return (((false || (t === 0)) === false) ? ((() => {
                return (ms + "-" + ((deselected.join)(",")));
            })()) : ((() => {
                return ms;
            })()));
        })(deselected.length));
    });
    var handle_work_button_click = (() => {
        return ((location)["href"] = ("/tag/" + (add_deselected_to_metas_string((metas__gstring()), (get_deselected_ids())))));
    });
    var handle_share_button_click = (() => {
        (copyToClipboard(("https://stxmat.dk/tag/" + (add_deselected_to_metas_string((metas__gstring()), (get_deselected_ids()))))));
        return (set_show_share_modal_p(true));
    });
    var work_button = ((React["createElement"])(Button, {
        variant: "primary",
        onClick: handle_work_button_click
    }, ((React["createElement"])(BootstrapIcon, {
        name: "pencil-fill"
    })), " Regn opgaverne"));
    var share_button = ((React["createElement"])(Button, {
        variant: "success",
        onClick: handle_share_button_click
    }, ((React["createElement"])(BootstrapIcon, {
        name: "upload"
    })), " Del opgaverne"));
    var on_close_share_button_modal = (() => {
        return (set_show_share_modal_p(false));
    });
    var share_modal = ((React["createElement"])(Modal, {
        show: show_share_modal_p,
        centered: true,
        size: "lg",
        onShow: (function() {
            return "done";
        }),
        aria_labelledby: "share-results-modal"
    }, ((React["createElement"])(Modal["Header"], {
        closeButton: ""
    }, ((React["createElement"])(Modal["Title"], {
        id: "exercise-modal"
    }, "Del Opgaverne")), "\n", ((React["createElement"])("a", {
        href: "#",
        onClick: on_close_share_button_modal
    }, ((React["createElement"])(BootstrapIcon, {
        name: "x-square-fill",
        style: "close-icon"
    })))))), "\n", ((React["createElement"])(Modal["Body"], null, "Et link til disse opgaver er nu kopieret til udklipsholderen. ", ((React["createElement"])("br", null)), "\n", "Sæt det ind i Lectio, en email eller lignende. ", ((React["createElement"])("br", null)), "\n", ((React["createElement"])("br", null)), "\n", "Link: ", ((React["createElement"])("a", {
        href: ("/tag/" + (add_deselected_to_metas_string((metas__gstring()), (get_deselected_ids()))))
    }, ("https://stxmat.dk/tag/" + (add_deselected_to_metas_string((metas__gstring()), (get_deselected_ids()))))))))));
    var select_styles = {
        menuList: (function(styles) {
            var new_styles = (Object());
            ((Object.assign)(new_styles, styles));
            ((Object.assign)(new_styles, {
                maxHeight: 400
            }));
            return new_styles;
        })
    };
    return ((React["createElement"])("div", null, ((React["createElement"])(Select, {
        value: (chosen_meta || undefined),
        defaultValue: undefined,
        placeholder: "Find opgaver: indtast emne, stikord eller opgave-id",
        inputValue: input_value,
        options: grouped_options,
        onChange: on_change_select,
        onInputChange: on_input_change,
        onKeyDown: on_key_down,
        isMulti: true,
        autoFocus: true,
        getOptionValue: (function(option) {
            return option.value;
        }),
        getOptionLabel: (function(option) {
            return option.lab;
        }),
        formatOptionLabel: format_option_label,
        formatGroupLabel: format_group_label,
        noOptionsMessage: (function() {
            return "Ingen opgaver fundet";
        }),
        loadingMessage: (function() {
            return "Henter data";
        }),
        styles: select_styles
    })), ((React["createElement"])("br", null)), work_button, ((React["createElement"])("span", {
        class: "pr-2"
    }, " ")), share_button, share_modal, ((React["createElement"])("br", null)), ((React["createElement"])("br", null)), ((React["createElement"])("div", null)), ((((metas__gstring()) === "") === false) ? ((React["createElement"])(TeaserList, {
        tag: (metas__gstring()),
        mode: "search-result"
    })) : "")));
};

function TeaserList(props) {
    var state_temp = ((React["useState"])(props.tag)),
        tag = state_temp[0],
        set_tag = state_temp[1];
    var state_temp_66 = ((React["useState"])(props.mode)),
        mode = state_temp_66[0],
        set_mode = state_temp_66[1];
    var state_temp_67 = ((React["useState"])(false)),
        data = state_temp_67[0],
        set_data = state_temp_67[1];
    var state_temp_68 = ((React["useState"])(false)),
        tag_to_ids = state_temp_68[0],
        set_tag_to_ids = state_temp_68[1];
    var state_temp_69 = ((React["useState"])(false)),
        ids = state_temp_69[0],
        set_ids = state_temp_69[1];
    var state_temp_70 = ((React["useState"])(false)),
        modal_shuffle_show = state_temp_70[0],
        set_modal_shuffle_show = state_temp_70[1];
    var state_temp_71 = ((React["useState"])(false)),
        modal_serial_show = state_temp_71[0],
        set_modal_serial_show = state_temp_71[1];
    var state_temp_72 = ((React["useState"])(false)),
        modal_adaptive_show = state_temp_72[0],
        set_modal_adaptive_show = state_temp_72[1];
    var state_temp_73 = ((React["useState"])(false)),
        all_ids = state_temp_73[0],
        set_all_ids = state_temp_73[1];
    (use_effect(typeset_entire_page));
    (use_effect((() => {
        (set_tag(props.tag));
        return (set_mode(props.mode));
    }), [props]));
    var handle_shuffle_start_on_click = (() => {
        return (set_modal_shuffle_show(true));
    });
    var handle_serial_start_on_click = (() => {
        return (set_modal_serial_show(true));
    });
    var handle_adaptive_start_on_click = (() => {
        return (set_modal_adaptive_show(true));
    });
    (((!data) === false) ? undefined : ((() => {
        return (((fetch_teasers("alle")).then)(set_data));
    })()));
    (((t) => {
        return (((false || (t === undefined) || (t === false)) === false) ? ((() => {
            return (((!all_ids) === false) ? undefined : ((() => {
                var alls = []; {
                    var a = data.ids,
                        n = a.length,
                        i = 0;
                    while ((true && true && (i < n))) {
                        (((id) => {
                            (alls[id] = true);
                            return (i += 1);
                        })(a[i]));
                    };
                    undefined;
                }
                return (set_all_ids(alls));
            })()));
        })()) : ((() => {
            return false;
        })()));
    })(data));
    (((!tag_to_ids) === false) ? undefined : ((() => {
        return (((fetch_tag_to_ids()).then)(set_tag_to_ids));
    })()));
    (((t) => {
        return (((false || (t === undefined) || (t === false)) === false) ? ((() => {
            var qs_ads = (parse_tag_query(tag));
            var qs = qs_ads[0];
            var ds = qs_ads[1];
            var new_ids = (array_union((((a) => {
                {
                    var a_74 = qs,
                        n = a_74.length,
                        i = 0;
                    while ((true && true && (i < n))) {
                        (((tags) => {
                            ((a.push)((array_intersection((((a_75) => {
                                {
                                    var a_78 = tags,
                                        n_76 = a_78.length,
                                        i_77 = 0;
                                    while ((true && true && (i_77 < n_76))) {
                                        (((tag_79) => {
                                            var is = tag_to_ids[tag_79];
                                            ((a_75.push)((((is === undefined) === false) ? is : ((all_ids[tag_79] === false) ? [] : [tag_79]))));
                                            return (i_77 += 1);
                                        })(a_78[i_77]));
                                    };
                                    undefined;
                                }
                                return a_75;
                            })([]))))));
                            return (i += 1);
                        })(a_74[i]));
                    };
                    undefined;
                }
                return a;
            })([]))));
            (new_ids = (array_substract(new_ids, ds)));
            var sorted_ids = ((new_ids.sort)());
            return (((!(equal_string_arrays_p(sorted_ids, ids))) === false) ? undefined : ((() => {
                return (set_ids(sorted_ids));
            })()));
        })()) : ((() => {
            return false;
        })()));
    })(tag_to_ids));
    return (((t) => {
        return (((false || (t === undefined) || (t === false)) === false) ? ((() => {
            var infos = (((a) => {
                {
                    var a_87 = data.titles,
                        n = a_87.length,
                        i = 0,
                        a_88 = data.summaries,
                        n_80 = a_88.length,
                        i_83 = 0,
                        a_89 = data.ids,
                        n_81 = a_89.length,
                        i_84 = 0,
                        a_90 = data.variantss,
                        n_82 = a_90.length,
                        i_85 = 0,
                        i_86 = 0;
                    while ((true && true && (i < n) && (i_83 < n_80) && (i_84 < n_81) && (i_85 < n_82) && true)) {
                        (((t_91, s, id, vs, j) => {
                            ((a.push)((((ids && ((ids.includes)(id))) === false) ? undefined : ((() => {
                                return {
                                    title: t_91,
                                    summary: s,
                                    id: id,
                                    variants: vs,
                                    key: j
                                };
                            })()))));
                            (i += 1);
                            (i_83 += 1);
                            (i_84 += 1);
                            (i_85 += 1);
                            return (i_86 += 1);
                        })(a_87[i], a_88[i_83], a_89[i_84], a_90[i_85], i_86));
                    };
                    undefined;
                }
                return a;
            })([]));
            (infos = ((infos.filter)(((x) => {
                return (!(x === undefined));
            }))));
            ((infos.sort)(((i1, i2) => {
                return (((compare_exercise_id(i1.id, i2.id)) === false) ? 1 : -1);
            })));
            var items = (((a) => {
                {
                    var a_92 = infos,
                        n = a_92.length,
                        i = 0;
                    while ((true && true && (i < n))) {
                        (((info) => {
                            ((a.push)(((React["createElement"])(Teaser, {
                                key: info.key,
                                tag: tag,
                                mode: mode,
                                title: info.title,
                                summary: info.summary,
                                id: info.id,
                                variant: (random(info.variants))
                            }))));
                            return (i += 1);
                        })(a_92[i]));
                    };
                    undefined;
                }
                return a;
            })([]));
            var shuffle_button = ((React["createElement"])(Button, {
                variant: "light",
                focus: "true",
                onClick: handle_shuffle_start_on_click
            }, ((React["createElement"])(BootstrapIcon, {
                name: "shuffle"
            })), " Blandet"));
            var serial_button = ((React["createElement"])(Button, {
                variant: "light",
                focus: "true",
                onClick: handle_serial_start_on_click
            }, ((React["createElement"])(BootstrapIcon, {
                name: "sort-down-alt"
            })), " I Rækkefølge"));
            var adaptive_button = ((React["createElement"])(Button, {
                variant: "light",
                focus: "true",
                disabled: "true",
                onClick: handle_adaptive_start_on_click
            }, ((React["createElement"])(BootstrapIcon, {
                name: "text-left"
            })), " Adaptivt"));
            var shuffle_modal = ((React["createElement"])(ExerciseModal, {
                show: modal_shuffle_show,
                onHide: (function() {
                    return (set_modal_shuffle_show(false));
                }),
                mode: "shuffle",
                exercise_ids: ids,
                exercise_id: (random_from_array(ids)),
                variant_id: 0
            }));
            var serial_modal = ((React["createElement"])(ExerciseModal, {
                show: modal_serial_show,
                onHide: (function() {
                    return (set_modal_serial_show(false));
                }),
                mode: "serial",
                exercise_ids: ids,
                exercise_id: ids[0],
                variant_id: 0
            }));
            var adaptive_modal = ((React["createElement"])(ExerciseModal, {
                show: modal_adaptive_show,
                onHide: (function() {
                    return (set_modal_adaptive_show(false));
                }),
                mode: "adaptive",
                exercise_ids: ids,
                exercise_id: ids[0],
                variant_id: 0
            }));
            var shuffle_card = ((React["createElement"])(Card, {
                bg: "danger",
                text: "white"
            }, ((React["createElement"])(Card["Header"], null, ((React["createElement"])(BootstrapIcon, {
                name: "shuffle"
            })), " Blandet")), "\n", ((React["createElement"])(Card["Body"], null, ((React["createElement"])(Card["Text"], null, "Regn opgaverne i tilfældig orden. ", ((React["createElement"])("br", null)), ((React["createElement"])("br", null)), "\n", shuffle_button, "  ", shuffle_modal))))));
            var serial_card = ((React["createElement"])(Card, {
                bg: "warning",
                text: "white"
            }, ((React["createElement"])(Card["Header"], null, ((React["createElement"])(BootstrapIcon, {
                name: "sort-down-alt"
            })), " Rækkefølge")), "\n", ((React["createElement"])(Card["Body"], null, ((React["createElement"])(Card["Text"], null, "Regn opgaverne i rækkefølge. ", ((React["createElement"])("br", null)), ((React["createElement"])("br", null)), "\n", " ", serial_button, " ", serial_modal))))));
            var adaptive_card = ((React["createElement"])(Card, {
                bg: "success",
                text: "white"
            }, ((React["createElement"])(Card["Header"], null, ((React["createElement"])(BootstrapIcon, {
                name: "text-left"
            })), " Adaptivt")), "\n", ((React["createElement"])(Card["Body"], null, ((React["createElement"])(Card["Text"], null, "Sværhedsgraden tilpasses løbende. ", ((React["createElement"])("br", null)), ((React["createElement"])("br", null)), "\n", adaptive_button, " ", adaptive_modal))))));
            return (((t_93) => {
                return (((false || (t_93 === "search-result")) === false) ? ((() => {
                    return (((t_94) => {
                        return (((false || (t_94 === 0)) === false) ? ((() => {
                            return ((React["createElement"])("div", null, ((React["createElement"])(Container, null, ((React["createElement"])(Row, null, ((React["createElement"])(Col, null, shuffle_card)), ((React["createElement"])(Col, null, serial_card)))))), ((React["createElement"])("br", null)), ((React["createElement"])("br", null)), items));
                        })()) : ((() => {
                            return ((React["createElement"])("div", null, ((React["createElement"])("p", null, "Ingen opgaver fundet. Find opgaver i emneoversigten eller på søgesiden.")), ((React["createElement"])("p", null, ((React["createElement"])("a", {
                                class: "btn btn-primary",
                                href: "/emner",
                                role: "button"
                            }, ((React["createElement"])(BootstrapIcon, null, "diagram-3-fill")), " Emneoversigt")), "\n", ((React["createElement"])("a", {
                                class: "btn btn-success",
                                href: "/search",
                                role: "button"
                            }, ((React["createElement"])(BootstrapIcon, null, "search")), " Søg"))))));
                        })()));
                    })(items.length));
                })()) : ((() => {
                    return ((React["createElement"])("div", null, items, ((React["createElement"])("br", null)), ((React["createElement"])("br", null))));
                })()));
            })(mode));
        })()) : ((() => {
            return ((React["createElement"])("div", null, "Ingen opgaver med tagget \"", tag, "\""));
        })()));
    })((ids && data)));
};

function CreateAccountForm(props) {
    var state_temp = ((React["useState"])({})),
        targets = state_temp[0],
        set_targets = state_temp[1];
    var state_temp_95 = ((React["useState"])({})),
        validation_status = state_temp_95[0],
        set_validation_status = state_temp_95[1];
    var state_temp_96 = ((React["useState"])({})),
        validation_needed_p = state_temp_96[0],
        set_validation_needed_p = state_temp_96[1];
    var state_temp_97 = ((React["useState"])(false)),
        show_invalid_p = state_temp_97[0],
        set_show_invalid_p = state_temp_97[1];
    (use_effect((() => {
        return ((validation_needed_p === false) ? undefined : ((() => {
            (validate_alphacode());
            (validate_username());
            return (set_validation_needed_p(false));
        })()));
    })));
    var update_status = ((id, valid_p) => {
        var new_status = {};
        ((Object.assign)(new_status, validation_status));
        (new_status[id] = valid_p);
        return (set_validation_status(new_status));
    });
    var all_lower_case_p = ((s) => {
        var r = (regexp("^[a-zæøå]*$"));
        return ((s.match)(r));
    });
    var all_legal_username_chars_p = ((s) => {
        var r = (regexp("^[a-zæøå0-9-]*$"));
        return ((s.match)(r));
    });
    var validate_username = (() => {
        var target = targets["username"];
        return (((!(target === undefined)) === false) ? undefined : ((() => {
            var v = target.value;
            var valid_p = (((string_length(v)) >= 3) && (all_legal_username_chars_p(v)));
            return (update_status("username", valid_p));
        })()));
    });
    var validate_alphacode = (() => {
        var target = targets["alphacode"];
        return (((!(target === undefined)) === false) ? undefined : ((() => {
            var v = target.value;
            var valid_p = (((string_length(v)) > 0) && (all_lower_case_p(v)));
            return (update_status("username", valid_p));
        })()));
    });
    var submit_create_account_form = ((e) => {
        (set_show_invalid_p(true));
        return (((validation_status["username"] && validation_status["alphacode"]) === false) ? ((() => {
            return ((e["preventDefault"])());
        })()) : ((() => {
            return "all-ok-submit-to-action";
        })()));
    });
    var handle_username_change = ((e) => {
        var ts = {};
        ((Object.assign)(ts, targets));
        (ts["username"] = e.target);
        (set_targets(ts));
        return (set_validation_needed_p(true));
    });
    var user_name_constraints_text = "Små bogstaver (a-å), cifre og bindestreg. Ingen mellemrum. Mindst 3 tegn.";
    return ((React["createElement"])(Form, {
        action: "/create-account-submitted",
        method: "post",
        onSubmit: submit_create_account_form
    }, ((React["createElement"])(Form["Group"], {
        controlId: "alphacode"
    }, ((React["createElement"])(Form["Label"], null, "Udleveret α-test-kode")), ((React["createElement"])(Form["Control"], {
        name: "alphacode",
        type: "text",
        placeholder: "",
        required: true
    })))), ((React["createElement"])(Form["Group"], {
        controlId: "username"
    }, ((React["createElement"])(Form["Label"], null, "Brugernavn")), ((React["createElement"])(Form["Control"], {
        name: "username",
        type: "text",
        placeholder: "",
        autoComplete: "username",
        onChange: handle_username_change,
        required: true,
        pattern: "^[a-zæøå0-9-]{3,}$",
        title: user_name_constraints_text,
        isValid: validation_status["username"],
        isInvalid: (show_invalid_p && (!validation_status["username"]))
    })), ((React["createElement"])(Form["Text"], {
        className: "text-muted"
    }, user_name_constraints_text)))), ((React["createElement"])(Form["Group"], {
        controlId: "password"
    }, ((React["createElement"])(Form["Label"], null, "Password")), ((React["createElement"])(Form["Control"], {
        name: "password",
        type: "password",
        placeholder: "",
        autoComplete: "new-password",
        required: true
    })))), ((React["createElement"])(Form["Group"], {
        controlId: "email"
    }, ((React["createElement"])(Form["Label"], null, "Email")), ((React["createElement"])(Form["Control"], {
        name: "email",
        type: "email",
        placeholder: "",
        autoComplete: "on",
        required: true
    })))), ((React["createElement"])(Form["Group"], {
        controlId: "firstname"
    }, ((React["createElement"])(Form["Label"], null, "Fornavn")), ((React["createElement"])(Form["Control"], {
        name: "firstname",
        type: "text",
        placeholder: "",
        autoComplete: "on",
        required: true
    })))), ((React["createElement"])(Form["Group"], {
        controlId: "surname"
    }, ((React["createElement"])(Form["Label"], null, "Efternavn")), ((React["createElement"])(Form["Control"], {
        name: "surname",
        type: "text",
        placeholder: "",
        autoComplete: "on",
        required: true
    })))), ((React["createElement"])(Button, {
        type: "submit",
        variant: "primary"
    }, "Opret"))));
};

function CreateLoginForm(props) {
    var state_temp = ((React["useState"])({})),
        targets = state_temp[0],
        set_targets = state_temp[1];
    var state_temp_98 = ((React["useState"])({})),
        validation_status = state_temp_98[0],
        set_validation_status = state_temp_98[1];
    var state_temp_99 = ((React["useState"])({})),
        validation_needed_p = state_temp_99[0],
        set_validation_needed_p = state_temp_99[1];
    var state_temp_100 = ((React["useState"])(false)),
        show_invalid_p = state_temp_100[0],
        set_show_invalid_p = state_temp_100[1];
    (use_effect((() => {
        return ((validation_needed_p === false) ? undefined : ((() => {
            (validate_username());
            return (set_validation_needed_p(false));
        })()));
    })));
    var update_status = ((id, valid_p) => {
        var new_status = {};
        ((Object.assign)(new_status, validation_status));
        (new_status[id] = valid_p);
        return (set_validation_status(new_status));
    });
    var all_lower_case_p = ((s) => {
        var r = (regexp("^[a-zæøå]*$"));
        return ((s.match)(r));
    });
    var all_legal_username_chars_p = ((s) => {
        var r = (regexp("^[a-zæøå0-9-]*$"));
        return ((s.match)(r));
    });
    var validate_username = (() => {
        var target = targets["username"];
        return (((!(target === undefined)) === false) ? undefined : ((() => {
            var v = target.value;
            var valid_p = (((string_length(v)) >= 3) && (all_legal_username_chars_p(v)));
            return (update_status("username", valid_p));
        })()));
    });
    var submit_login_form = ((e) => {
        (set_show_invalid_p(true));
        return ((validation_status["username"] === false) ? ((() => {
            return ((e["preventDefault"])());
        })()) : ((() => {
            return "all-ok-submit-to-action";
        })()));
    });
    var handle_username_change = ((e) => {
        var ts = {};
        ((Object.assign)(ts, targets));
        (ts["username"] = e.target);
        (set_targets(ts));
        return (set_validation_needed_p(true));
    });
    var user_name_constraints_text = "Små bogstaver (a-å), cifre og bindestreg. Ingen mellemrum. Mindst 3 tegn.";
    return ((React["createElement"])(Form, {
        action: "/login-submitted",
        method: "post",
        onSubmit: submit_login_form
    }, ((React["createElement"])(Form["Group"], {
        controlId: "username"
    }, ((React["createElement"])(Form["Label"], null, "Brugernavn")), ((React["createElement"])(Form["Control"], {
        name: "username",
        type: "text",
        placeholder: "",
        autoComplete: "username",
        title: user_name_constraints_text,
        onChange: handle_username_change,
        required: true,
        pattern: "^[a-zæøå0-9-]{3,}$",
        isValid: validation_status["username"],
        isInvalid: (show_invalid_p && (!validation_status["username"]))
    })), ((React["createElement"])(Form["Text"], {
        className: "text-muted"
    }, user_name_constraints_text)))), ((React["createElement"])(Form["Group"], {
        controlId: "password"
    }, ((React["createElement"])(Form["Label"], null, "Password")), ((React["createElement"])(Form["Control"], {
        name: "password",
        type: "password",
        placeholder: "",
        autoComplete: "current-password",
        required: true
    })))), ((React["createElement"])(Button, {
        type: "submit",
        variant: "primary"
    }, ((React["createElement"])(BootstrapIcon, {
        name: "box-arrow-in-right"
    })), "  Login"))));
};

function EditableMathField(props) {
    ((console.log)("EditableMathField"));
    ((console.log)("props:", props));
    var initial_latex = (ref_qfalse(props, "initial_latex"));
    var on_change = (ref_qfalse(props, "on_change"));
    var config = (ref_qfalse(props, "config"));
    var mathquill_did_mount = (ref_qfalse(props, "mathquill_did_mount"));
    var other_props = (((props === undefined) === false) ? ((() => {
        var ps = ((Object.assign)({}, props));
        (delete ps["initial_latex"]);
        (delete ps["on_change"]);
        (delete ps.config);
        (delete ps["mathquill_did_mount"]);
        return ps;
    })()) : ((() => {
        return {};
    })()));
    ((console.log)("initial-latex", initial_latex));
    ((console.log)("on-change", on_change));
    ((console.log)("config", config));
    ((console.log)("mathquill-did-mount", mathquill_did_mount));
    ((console.log)("other-props", other_props));
    var mathfield = (use_ref(false));
    var wrapper_element = (use_ref(false));
    var ignore_edit_events = (use_ref(0));
    var on_change_ref = (use_ref(on_change));
    (use_effect((() => {
        return ((on_change_ref)["current"] = on_change);
    })));
    (use_effect((() => {
        return ((wrapper_element === false) ? undefined : ((() => {
            var config_defaults = {
                latex: initial_latex,
                restrictMismatchedBracket: true,
                handlers: {}
            };
            var config_with_defaults = ((Object.assign)({}, config_defaults));
            ((Object.assign)(config_with_defaults, config));
            var the_edit_handler = config_with_defaults.handlers.edit;
            var edit_handler = ((mathfield_101) => {
                (((!(undefined_p(the_edit_handler))) === false) ? undefined : ((() => {
                    return (the_edit_handler());
                })()));
                return (((ignore_edit_events.current > 0) === false) ? ((() => {
                    return (((ref_qfalse(on_change_ref, "current")) === false) ? undefined : ((() => {
                        return ((on_change_ref.current)(mathfield_101));
                    })()));
                })()) : ((() => {
                    return ((ignore_edit_events)["current"] = (ignore_edit_events.current - 1));
                })()));
            });
            ((config_with_defaults)["handlers"]["edit"] = edit_handler);
            ((console.log)("config-with-defaults", config_with_defaults));
            ((mathfield)["current"] = ((MQ["MathField"])(wrapper_element.current, config_with_defaults)));
            ((mathfield.current.latex)((initial_latex || "")));
            return ((mathquill_did_mount === false) ? undefined : ((() => {
                return (mathquill_did_mount(mathfield.current));
            })()));
        })()));
    }), [wrapper_element]));
    (use_effect((() => {
        ((console.log)("1", mathfield.current));
        return (((!(undefined_p(mathfield.current))) === false) ? undefined : ((() => {
            ((console.log)("2", mathfield.current.latex));
            ((console.log)("3", initial_latex));
            return (((!(mathfield.current.latex === initial_latex)) === false) ? undefined : ((() => {
                return ((mathfield.current.latex)(initial_latex));
            })()));
        })()));
    }), [initial_latex]));
    return ((React["createElement"])("span", ((Object.assign)({}, {
        ref: wrapper_element
    }, other_props))));
};

function EditableMathExample() {
    var initial_latex = "a^2 + b^2 = c^2";
    var state_temp = ((React["useState"])(initial_latex)),
        latex = state_temp[0],
        set_latex_e = state_temp[1];
    var state_temp_102 = ((React["useState"])("")),
        text = state_temp_102[0],
        set_text_e = state_temp_102[1];
    var make_on_change = (() => {
        return ((mf) => {
            return (((!(undefined_p(mf))) === false) ? undefined : ((() => {
                ((console.log)("on-change 1:", mf));
                (set_latex_e(((mf.latex)())));
                ((console.log)("on-change 2:", ((mf.latex)())));
                return ((console.log)("on-change 3:", latex));
            })()));
        });
    });
    var make_on_did_mount = (() => {
        return ((mf) => {
            ((console.log)("on-did-mount 1", mf));
            (set_text_e(((mf.text)())));
            return ((console.log)("on-did-mount 2", text));
        });
    });
    return ((React["createElement"])("div", null, ((React["createElement"])("h2", null, "Editable Math Field")), ((React["createElement"])(EditableMathField, {
        className: "mathquill-example-field",
        initial_latex: "2+x=5",
        on_change: (make_on_change()),
        mathquill_did_mount: (make_on_did_mount()),
        config: {}
    })), ((React["createElement"])("div", null, ((React["createElement"])("spand", null, "Latex: ", latex)))), ((React["createElement"])("div", null, ((React["createElement"])("spand", null, "Text: ", text))))));
};

function StaticMathField(props) {
    var mathquill_did_mount = props["mathquillDidMount"];
    var children = props.children;
    var other_props = (((props === undefined) === false) ? ((() => {
        var ps = ((Object.assign)({}, props));
        (delete ps["mathquillDidMount"]);
        (delete ps.children);
        return ps;
    })()) : ((() => {
        return {};
    })()));
    var wrapper_element = (use_ref(null));
    var mathfield = (use_ref(null));
    (use_layout_effect((() => {
        return (((!(wrapper_element === undefined)) === false) ? undefined : ((() => {
            ((mathfield)["current"] = ((MQ["StaticMath"])(wrapper_element.current)));
            return (((!(mathquill_did_mount === undefined)) === false) ? undefined : ((() => {
                return (mathquill_did_mount(mathfield.current));
            })()));
        })()));
    }), [wrapper_element, children]));
    return ((React["createElement"])("span", ((Object.assign)({}, {
        ref: wrapper_element
    }, other_props)), children));
};

function StaticMathExample() {
    var first_latex = "a^2 + b^2 = c^2";
    var second_latex = "\\sqrt{\\frac{a}{b}}";
    var state_temp = ((React["useState"])(first_latex)),
        latex = state_temp[0],
        set_latex_e = state_temp[1];
    var on_change = (() => {
        return (set_latex_e((((latex === first_latex) === false) ? first_latex : second_latex)));
    });
    return ((React["createElement"])("div", null, ((React["createElement"])("h2", null, "Static Math Field")), ((React["createElement"])(StaticMathField, null, latex)), ((React["createElement"])("br", null)), ((React["createElement"])(Button, {
        variant: "primary",
        onClick: on_change,
        focus: "true"
    }, "Klik"))));
};

function MathQuillApp(props) {
    var state_temp = ((React["useState"])(0)),
        count = state_temp[0],
        set_count = state_temp[1];
    var handle_on_click = (() => {
        return (set_count((count + 1)));
    });
    return ((React["createElement"])("div", null, ((React["createElement"])(StaticMathExample, null)), ((React["createElement"])(EditableMathExample, null))));
};

function $0(selector) {
    return ($(selector))[0];
};
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        var props = {
            mode: "single",
            exercise_id: ((elm["getAttribute"])("exercise-id"))
        };
        return ((ReactDOM.render)(((React["createElement"])(App, props)), elm));
    })()));
})(($0("#the-exercise-element"))));
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        var props = {
            tag: ((elm["getAttribute"])("tag"))
        };
        return ((ReactDOM.render)(((React["createElement"])(TeaserList, props)), elm));
    })()));
})(($0("#the-tagged-exercises-element"))));
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        return ((ReactDOM.render)(((React["createElement"])(SearchField, [])), elm));
    })()));
})(($0("#the-search-element"))));
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        var props = {
            tag: ((elm["getAttribute"])("tag"))
        };
        return ((ReactDOM.render)(((React["createElement"])(CreateAccountForm, props)), elm));
    })()));
})(($0("#the-create-account-element"))));
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        var props = {
            tag: ((elm["getAttribute"])("tag"))
        };
        return ((ReactDOM.render)(((React["createElement"])(CreateLoginForm, props)), elm));
    })()));
})(($0("#the-login-element"))));
(((elms) => {
    return ((() => {
        var a = elms,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((e) => {
                (e["innerHTML"] = ((e["getAttribute"])("html")));
                return (i += 1);
            })(a[i]));
        };
        undefined;
        return undefined;
    })());
})(($(".summary"))));
((console.log)("Initializing MathQuill"));
var MQ = ((MathQuill["getInterface"])(MathQuill["getInterface"]["MAX"]));
(((elms) => {
    return ((() => {
        var a = elms,
            n = a.length,
            i = 0;
        while ((true && true && (i < n))) {
            (((e) => {
                ((MQ["MathField"])(e));
                return (i += 1);
            })(a[i]));
        };
        undefined;
        return undefined;
    })());
})(($(".mathquill-math-field"))));
(((elm) => {
    return (((!(elm === undefined)) === false) ? undefined : ((() => {
        var props = {
            tag: ((elm["getAttribute"])("tag"))
        };
        return ((ReactDOM.render)(((React["createElement"])(MathQuillApp, props)), elm));
    })()));
})(($0("#the-mathquill-test-app"))));